import { useEffect, useState } from "react";
import { MDBBtn } from "mdbreact";
import {
  allServicesHavePrices,
  capitalize,
  computeGD,
  currency,
} from "../../../../../../../services/utilities";
import { Categories, Payments } from "../../../../../../../services/fakeDb";
import { UPDATE as PATIENTUPDATE } from "../../../../../../../services/redux/slices/assets/persons/users";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
  RESET,
  RESET_CARDHOLDER,
  RESET_INSOURCE,
  SAVE,
  SETCART,
} from "../../../../../../../services/redux/slices/commerce/pos/services/pos";
import { removeUndefinedValues } from "../../../../../../../services/utilities";
import { useToasts } from "react-toast-notifications";
import { SetPrinting } from "../../../../../../../services/redux/slices/commerce/pos/services/deals";
import Spinner from "../../../../../../../components/spinner";
import { ADD_AFFILIATED } from "../../../../../../../services/redux/slices/assets/providers";
import { ADD_PHYSICIAN } from "../../../../../../../services/redux/slices/assets/persons/physicians";
import RollingNumber from "../../../../../../../components/rollingNumber";
import utils from "./utils";
import Payment from "./payment";

const _refNo = {
  number: "",
  amount: 0,
  pp: "cash", //cash or credit patient Payable
  careOf: {
    category: "employee",
    number: "", //reference number for gcash
    user: "",
    amount: 0,
    pp: "gcash",
  },
};

export default function Summary() {
  const { token, activePlatform, auth } = useSelector(({ auth }) => auth),
    {
      cart,
      category,
      privilege,
      customer = {},
      physicianId,
      sourceId,
      ssx,
      authorizedBy,
      department,
      hmo,
      formSubmitted = false,
      cardHolder,
    } = useSelector(({ pos }) => pos),
    [isPickup, setIsPickup] = useState(true),
    [isVoucher, setIsVoucher] = useState(false),
    [refNo, setRefNo] = useState(_refNo),
    [payment, setPayment] = useState("cash"),
    [cash, setCash] = useState(0),
    { addToast } = useToasts(),
    dispatch = useDispatch();

  const cardHolderProvider =
    cardHolder?.provider ||
    (cardHolder?.type === "wls"
      ? cardHolder?.company?.name || ""
      : cardHolder?.type || "");
  const cardHolderType =
    cardHolder?.type ||
    (cardHolderProvider === "phi"
      ? "phi"
      : ["mbs", "ctr"].includes(cardHolderProvider)
        ? cardHolderProvider
        : cardHolderProvider
          ? "wls"
          : "");

  const hasCardHolderDetails = (holder = {}) => {
    const provider =
      holder?.provider ||
      (holder?.type === "wls"
        ? holder?.company?.name || ""
        : holder?.type || "");
    const { company = {} } = holder || {};
    return Boolean(provider || company?.name || company?.ref);
  };

  const getSelectedHealthCard = () => {
    const isHMO = cardHolderType === "wls";
    const isPhilHealth = cardHolderType === "phi";
    const provider = isHMO
      ? String(cardHolderProvider || "").toLowerCase()
      : isPhilHealth
        ? "phi"
        : "";
    const selectedRef = String(cardHolder?.company?.ref || "");
    const healthCards = Array.isArray(customer?.healthCard)
      ? customer.healthCard
      : [];

    return (
      healthCards.find(({ _id, number = "", provider: itemProvider = "" }) => {
        if (itemProvider !== provider) return false;
        if (!selectedRef) return true;

        return (
          String(_id || "") === selectedRef || String(number || "") === selectedRef
        );
      }) || {}
    );
  };

  const {
      gross = 0,
      discount: rawDiscount = 0,
      vat = 0,
      vatExempt = 0,
      lessDiscount = 0,
    } = computeGD(cart, category, privilege, cardHolder),
    hasVatExempt = vat > 0,
    // only the amount due is rounded to whole pesos, discount absorbs the centavos
    amount = Math.round((gross || 0) - (rawDiscount || 0)),
    discount = (gross || 0) - amount,
    { abbr = undefined } = Categories[category],
    providedPaymentOptions = Payments[cardHolderType ? cardHolderType : abbr];

  useEffect(() => {
    setPayment(
      ["mbs", "wls", "ctr", "phi"].includes(cardHolderType)
        ? "voucher"
        : "cash"
    );
    setRefNo({ ..._refNo, pp: "cash" });
  }, [cardHolder, cardHolderType]);

  useEffect(() => {
    setIsVoucher(payment === "voucher");
  }, [payment]);
  const checkout = async () => {
    const baseRefNo = utils.build(refNo, payment, amount, cardHolder);
    const _cash =
      utils.hasCash(refNo, payment, amount) && payment !== "mixed" ? cash : 0;
    const normalizedCardHolder = removeUndefinedValues({
      provider: cardHolderProvider,
      company: cardHolder?.company,
      ...(cardHolder?.tier && { tier: cardHolder.tier }),
    });
    let selected = {
      physicianId: physicianId?.physician || undefined,
      source: sourceId || undefined,
      authorizedBy: authorizedBy || undefined,
      ssx: ssx || undefined,
      branchId: activePlatform.branchId,
      customerId: customer._id,
      cashierId: auth._id,
      category: category === 0 ? "wi" : abbr,
      payment,
      cash: _cash,
      amount,
      discount,
      ...(hasVatExempt && { vat, vatExempt, lessDiscount }),
      isPickup,
      department,
      privilege,
      customer,
      cashier: auth?.fullName,
      isPrint: true,
      status: "pending",
      ...(cardHolderProvider && { cardHolder: normalizedCardHolder }),
      ...(baseRefNo && {
        refNo: baseRefNo,
      }),
      cart: cart.map((menu) => {
        const {
            description,
            abbreviation,
            capital,
            packages = [],
            _id,
            isNew,
          } = menu,
          { up, discount: soldDiscount } = computeGD(
            menu,
            category,
            privilege,
            cardHolder
          );

        return {
          capital,
          description: String(description).toUpperCase(),
          abbreviation,
          packages,
          menuId: _id,
          isNew,
          up: up,
          discount: soldDiscount,
        };
      }),
    };
    const balance = _cash - amount;

    if (balance > 0)
      Swal.fire({
        icon: "info",
        title: `Change: ${currency.format(balance)}`,
        text: "Please return the change to the customer.",
      });

    if (customer?.privilege !== privilege && privilege !== 4)
      dispatch(
        PATIENTUPDATE({
          token,
          data: { _id: customer._id, privilege },
        })
      );
    selected = removeUndefinedValues(selected);
    try {
      await dispatch(SAVE({ token, data: selected })).then(
        ({ payload: data }) => {
          const { payload, register } = data;
          selected._id = payload._id;
          dispatch(SetPrinting({ status: true, selected }));
          if (register.isRegister) {
            dispatch(ADD_AFFILIATED(register));
            dispatch(ADD_PHYSICIAN(register.physician));
          }
        }
      );
      dispatch(RESET_CARDHOLDER());
      dispatch(SETCART());
      setRefNo(_refNo);
      addToast("Transaction completed successfully", { appearance: "info" });
    } catch (error) {
      addToast("Transaction failed", { appearance: "error" });
    } finally {
      setCash(0);
      dispatch(RESET());
      dispatch(RESET_INSOURCE());
      // 🔥 Dispatch the event
      window.dispatchEvent(new Event("reset-ui"));
    }
  };

  const showAlert = (text) => {
    return Swal.fire({
      title: "Company Card Needed",
      text,
      icon: "warning",
      confirmButtonText: "Got it",
      confirmButtonColor: "#4CAF50",
      background: "#ffffff",
      backdrop: `rgba(0,0,0,0.4)`,
      allowOutsideClick: false,
    });
  };

  const handleCheckout = async (e) => {
    e.preventDefault();
    const { company = { name: "", ref: "" } } = cardHolder || {};
    const { ref = "" } = company || {};
    const { careOf = {} } = refNo;
    if (
      careOf.pp === "co" &&
      !careOf.user &&
      (payment === "mixed" || payment === "voucher")
    ) {
      const category = {
        bm: "Board Member",
        employee: "Employee",
        physician: "Physician",
      };
      return Swal.fire({
        icon: "warning",
        title: `${category[careOf.category]} Required`,
        text: `Please select a ${
          category[careOf.category]
        } who will take care of this credit transaction.`,
        confirmButtonText: "Got it",
        confirmButtonColor: "#3085d6",
        backdrop: true,
      });
    }
    if (cardHolderType === "ctr" && !ref) {
      return showAlert(
        "Please select a company card for the Card Holder contract before continuing."
      );
    }

    if (cardHolderType === "mbs" && !ref) {
      return showAlert(
        "Please select a company card  for the Card Holder Membership before continuing."
      );
    }

    if (cardHolderType === "wls" && !ref) {
      return showAlert(
        "Please select a company card  for the HMO Card Holder before continuing."
      );
    }

    if (["wls", "phi"].includes(cardHolderType)) {
      const healthCard = getSelectedHealthCard();
      if (!ref || !healthCard?.number || !healthCard?.memberType) {
        return Swal.fire({
          icon: "warning",
          title: `Incomplete ${
            cardHolderType === "wls" ? "HMO" : "PhilHealth"
          } Details`,
          text: `Please update the patient's ${
            cardHolderType === "wls" ? "HMO" : "PhilHealth"
          } details first. Card/Member No. and Member Type are required.`,
          confirmButtonText: "Got it",
          confirmButtonColor: "#3085d6",
          backdrop: true,
        });
      }
    }

    if (!allServicesHavePrices(cart, category, hmo)) {
      Swal.fire({
        title: "Service Validator?",
        text: "Some services do not have a set price. Please double-check. If you're confident everything is correct, you may proceed. Note that the admin will be notified regarding this issue.",
        icon: "error",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, proceed",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await checkout();
        }
      });
    } else {
      await checkout();
    }
  };

  return (
    <form onSubmit={handleCheckout}>
      <table className="summary-table">
        <thead>
          <tr>
            <th colSpan="2" className="th-custom">
              summary
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ fontSize: "1rem" }}>Gross Amount</td>
            <td className="table-price">
              <div className="d-flex justify-content-end">
                <RollingNumber value={gross} duration={1000} />
              </div>
            </td>
          </tr>
          <tr>
            <td style={{ fontSize: "1rem" }}>
              {hasVatExempt ? "Discount 20%" : "Discount"}
            </td>
            <td className="table-price">
              <div className="d-flex justify-content-end">
                <RollingNumber
                  value={hasVatExempt ? lessDiscount : discount}
                  duration={1000}
                />
              </div>
            </td>
          </tr>
          {hasVatExempt && (
            // VAT is added back, the patient pays it (same as the invoice)
            <tr>
              <td style={{ fontSize: "1rem" }}>VAT 12%</td>
              <td className="table-price">
                <div className="d-flex justify-content-end">
                  <RollingNumber value={vat} duration={1000} />
                </div>
              </td>
            </tr>
          )}
          <tr>
            <td style={{ fontSize: "1rem" }}>Net Amount</td>
            <td className="table-price">
              <div className="d-flex justify-content-end">
                <RollingNumber value={amount} duration={1000} />
              </div>
            </td>
          </tr>
          <tr>
            <td style={{ fontSize: "1rem" }}>Payment</td>
            <td className="p-0">
              <select
                value={payment}
                onChange={({ target }) => {
                  const _payment = target.value;
                  const isCardHolder = hasCardHolderDetails(cardHolder);
                  const careOfPP =
                    _payment === "mixed"
                      ? "cash"
                      : isCardHolder ||
                        _payment === "cash" ||
                        _payment === "downpayment"
                      ? "cash"
                      : "co";

                  setPayment(_payment);
                  setRefNo({
                    ..._refNo,
                    pp: careOfPP,
                  });
                }}
              >
                {providedPaymentOptions?.map((payment, index) => (
                  <option key={`${abbr}-${index}`} value={payment}>
                    {capitalize(payment === "mixed" ? "Split Bill" : payment)}
                  </option>
                ))}
              </select>
            </td>
          </tr>
          {["voucher", "mixed"].includes(payment) && (
            <Payment
              payment={payment}
              refNo={refNo}
              setRefNo={setRefNo}
              chargeAmount={amount}
              setCash={setCash}
              cash={cash}
            />
          )}

          {["cash", "downpayment", "voucher"].includes(payment) &&
          refNo.pp === "cash" &&
          (refNo?.amount < amount || !refNo.amount) ? (
            <tr>
              <td style={{ fontSize: "1rem" }}>Amount ₱</td>
              <td className="p-0">
                <input
                  type="number"
                  min={isVoucher ? amount - refNo.amount : amount}
                  value={String(cash || "")}
                  onChange={({ target }) => setCash(Number(target.value))}
                  placeholder={
                    isVoucher
                      ? `Amount ${currency.format(amount - refNo.amount)}`
                      : "Amount"
                  }
                  required
                  title={
                    isVoucher
                      ? `Amount ${currency.format(amount - refNo.amount)}`
                      : "Amount "
                  }
                  name="amount"
                />
              </td>
            </tr>
          ) : (
            ""
          )}

          <tr>
            <td className="p-0">
              <button
                type="button"
                className={`type-of-transport ${isPickup && "active"}`}
                onClick={() => setIsPickup(true)}
              >
                Pick-up
              </button>
            </td>
            <td className="p-0">
              <button
                type="button"
                className={`type-of-transport ${!isPickup && "active"}`}
                onClick={() => setIsPickup(false)}
              >
                Deliver
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <MDBBtn
        type="submit"
        disabled={formSubmitted || !cart.length}
        className="m-0 w-100 fw-bold mt-4"
        color="success"
      >
        Complete Transaction <Spinner formSubmitted={formSubmitted} />
      </MDBBtn>
    </form>
  );
}
